import React from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import { useTranslation } from "react-i18next"

const TextTeaserImageBlock = ({ block }) => {
  const { t } = useTranslation()
  return (
    <BlockWrapper
      block={block}
      blockWidth="container"
      showHeadline="true"
      className=""
    >
      <div className="mt-8">
        <Richtext text={block.text} />
        <div className="flex flex-row flex-wrap mt-8 -mx-grid">
          <div className="w-full px-grid md:w-1/2 md:order-last">
            <Image
              className="w-full h-auto mb-8 rounded-xl"
              image={block.image}
              aspectRatio={block.aspect_ratio}
            />
          </div>
          <div className="w-full px-grid md:w-1/2">
            <div className="flex flex-col flex-wrap -mx-grid">
              {block.textteaser_items?.length > 0 &&
                block.textteaser_items.map((item, index) => (
                  <div key={index} className="w-full px-grid">
                    <Link
                      link={item.link}
                      className="relative block py-4 pr-4 mb-8 overflow-hidden pl-7 group hover-shadow rounded-xl"
                    >
                      <span className="absolute top-0 left-0 w-3 h-full transition-colors duration-300 bg-gray-300 group-hover:bg-accent-hover"></span>
                      <span className="font-semibold">{item.title}</span>
                      <p className="prose text-gray-500">{item.text}</p>
                      <span className="block mt-8 text-primary group-hover:text-primary-hover">
                        {t("cards.read-more")}
                      </span>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default TextTeaserImageBlock
